import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import useStateRef from 'react-usestateref';
import Helper from '../Helper';
import { APPLICATION_JSON, DEFAULT_IMAGE_140 } from '../../middleware/types';
import Loader from '../Loader/Loader';
import OrderSummary from './OrderSummary';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { checkOutHeaderOptionsAction } from '../../middleware/CheckOutHeaderOptionsAction';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';

function CheckoutReview({ containerObject, templateName, contentId, dataZone }) {
    const [showTooltip, setShowTooltip] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [creditCardError, setCreditCardError] = useState(true);
    const [submitButton, setSubmitButton] = useState("Submit Order");
    const [specialInstruction, setSpecialInstruction, specialInstructionRef] = useStateRef([]);
    const [search, setSearch, searchRef] = useStateRef("");
    const [reviewDetails, setReviewDetails, reviewDetailsRef] = useStateRef("");
    const [redeemReviewDetails, setRedeemReviewDetails, redeemReviewDetailsRef] = useStateRef("");
    const [redeemProductDetails, setRedeemProductDetails, redeemProductDetailsRef] = useStateRef('')
    // const [orgBillingAddress, setOrgBillingAddress, orgBillingAddressRef] = useStateRef()
    const [orderSummaryDetails, setOrderSummaryDetails, orderSummaryDetailsRef] = useStateRef('');
    const [specialProductItem, setSpecialProductItem, specialProductItemRef] = useStateRef("");
    const [livingProductItem, setLivingProductItem, livingProductItemRef] = useStateRef("");
    const [isDistanceLearning, setIsDistanceLearning, isDistanceLearningRef] = useStateRef(false);
    const [nonLivingProductItem, setNonLivingProductItem, nonLivingProductItemRef] = useStateRef("");
    const [shipPreference, setShipPreference, shipPreferenceRef] = useStateRef(false);
    const [dataLayer, setDataLayer, dataLayerRef] = useStateRef('');
    const history = useHistory()
    const location = useLocation();
    const showDelivery = useSelector(state => state.checkOutHeaderOptions.showDelivery);
    const [restrictRepeatCall, setRestricRepeatCall, restrictRepeatCallRef] = useStateRef(false);
    const dispatch = useDispatch();
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    //get call for review details
    useEffect(() => {
        if (loaderStatus == true) {
            console.log("log in review page loader true");
        } else {
            console.log("log in review page loader false");
            setSearch(window.location.pathname)

            if (searchRef.current == "/checkout/review") {
                getOrderSummaryDetails();
            }

            if (searchRef.current == "/checkout/review") {
                // setIsLoading(true);
                fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/review-page`, {
                    method: 'GET'
                }).then(res => res.json())
                    .then(res => {
                        if (res.result === "success") {
                            setIsLoading(false);
                            var parsedResponse = JSON.parse(res.response);
                            var response = parsedResponse.response
                            setReviewDetails(response)
                            console.log("reviewDetailsRef.current", reviewDetailsRef.current)
                            //populateDataLayer();

                        } else {
                            setIsLoading(false);
                            const error = res._ERROR_MESSAGE_;
                        }
                    })
                   
            }
            if (searchRef.current == "/voucher/review") {
                // setIsLoading(true);
                fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/redeem/review`, {
                    method: 'GET'
                }).then(res => res.json())
                    .then(res => {
                        if (res.result === "success") {
                            setIsLoading(false);
                            var parsedResponse = JSON.parse(res.response);
                            var response = parsedResponse.response
                            setRedeemReviewDetails(response)
                            setRedeemProductDetails(response.productDetail);
                            setSubmitButton("Submit Voucher Redemption")
                            if (redeemProductDetailsRef?.current?.distanceLearning.length > 0) {
                                setIsDistanceLearning(true);
                            }

                        } else {
                            setIsLoading(false);
                            const error = res._ERROR_MESSAGE_;
                        }
                    })
                    
            }
        }

    }, [])


    const populateDataLayer = () => {
        reviewDetailsRef.current && reviewDetailsRef.current.map((detail, key) => {
            setShipPreference(detail)
            if (detail.dataLayerObject) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push(detail.dataLayerObject.dataLayerJson)

            }
        })
    }

    function handleCallBackOrderSummary() {
        getOrderSummaryDetails();
    }



    const getOrderSummaryDetails = async () => {
        const body = {
            "isReviewPage": true,
            "isShippingPage": false,
            "requiredReprice": true
        }
        var orderSummary = await Helper.getOrderSummary(body);
        setOrderSummaryDetails(orderSummary);
    }
    function handleDateCompare(start, end) {
        let startDate = handleDateFormat(start)
        let endDate = handleDateFormat(end)
        if (startDate == endDate) {
            return "equal"
        }
        return "notEqual"
    }

    function handleDateFormat(dates) {
        let date = new Date(dates);
        let year = date.getFullYear();
        let month = date.getMonth() + 1; // JavaScript months are 0-indexed
        let day = date.getDate();
        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;
        var formattedDate = month + '/' + day + '/' + year;
        return formattedDate;
    }
    function replaceImage(event) {
        event.target.src = DEFAULT_IMAGE_140;
    }

    var specialProduct = []
    var livingProduct = []
    var nonLivingProduct = []
    var allSpecialProducts = []
    var hideEditButton = "false"

    //set the products in respective state
    useEffect(() => {

        if (reviewDetailsRef.current) {
            reviewDetailsRef.current.map((details) => {

                // special product
                details.dropShipItems ? specialProduct.push(details.dropShipItems) : ""
                details.groundOnlyItems ? specialProduct.push(details.groundOnlyItems) : ""
                details.softGoodsItems ? specialProduct.push(details.softGoodsItems) : ""
                details.backOrderLivingMaterialItems ? specialProduct.push(details.backOrderLivingMaterialItems) : ""
                details.rtsProductItems ? specialProduct.push(details.rtsProductItems) : ""


                // living product
                details.livingMaterialItems ? livingProduct.push(details.livingMaterialItems) : ""
                details.specialLivingMaterialItems ? livingProduct.push(details.specialLivingMaterialItems) : ""

                // non-living product
                details.nonLivingCategoryItems ? nonLivingProduct.push(details.nonLivingCategoryItems) : ""


                setSpecialInstruction(details?.repoItemsMessage);
            })
        }
        if (specialProduct.length > 0) {
            setSpecialProductItem(specialProduct)
        }
        if (livingProduct.length > 0) {
            setLivingProductItem(livingProduct)
        }
        if (nonLivingProduct.length > 0) {
            setNonLivingProductItem(nonLivingProduct)
        }

    }, [reviewDetailsRef.current])


    // handle for submiting order
    async function handleSubmitOrder(event) {
        event.preventDefault();
        if (!restrictRepeatCallRef.current) {
            setRestricRepeatCall(true);
            console.log('handleSubmitOrder called...');
            setIsLoading(true)
            if (searchRef.current == "/checkout/review") {
                localStorage.removeItem('specialInstruction');
                localStorage.removeItem('additionalInstruction');
                var specialRequest = document.getElementById("specialRequest").value;

                var specialInstructions = "";
                if (specialRequest !== "") {
                    specialInstructions = document.getElementById("specialInstructions").value;
                }

                var actionUrl = "api/rest/cb/checkout/submit-order";
                var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`

                if (orderSummaryDetailsRef.current) {
                    var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
                        specialInstructions: specialInstructions,
                    }))

                    const response = JSON.parse(res.response);
                    if (res.result === "success" && response.status === "success") {
                        setIsLoading(false)
                        dispatch(updateProfileDetailsAction(true, "clearCart"))
                        setRestricRepeatCall(false);
                        history.push("/checkout/confirm");
                    } else if (response.status == "error") {
                        response.errorMessage.map((error) => {
                            setRestricRepeatCall(false);
                            history.push("/checkout/billing", error);
                            // if(error.key === ""){
                            //     history.push("/checkout/billing", error);
                            // }else if(error.key === ""){
                            //     history.push("/checkout/billing", error);
                            // }
                        })
                        setIsLoading(false)
                    } else {
                        setRestricRepeatCall(false);
                        setIsLoading(false)

                    }
                } else {
                    setRestricRepeatCall(false);
                    setIsLoading(false)
                    console.log("Kindly wait order summary is Loading ....");
                }
            }
            if (searchRef.current == "/voucher/review") {
                setIsLoading(true)
                var actionUrl = "api/rest/cb/redeem/submit-order";
                var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
                var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
                    successURL: "/voucher/confirm",
                    failureURL: "/voucher/review",
                    voucherSubmit: "Submit+Voucher+Redemption"
                }))

                const response = JSON.parse(res.response);
                if (res.result === "success" && response.status === "success") {
                    setIsLoading(false)
                    setRestricRepeatCall(false)
                    history.push("/voucher/confirm");
                } else if (response.status == "error") {
                    setIsLoading(false)
                    setRestricRepeatCall(false)
                    history.push("/voucher/review");
                } else {
                    setRestricRepeatCall(false)
                    setIsLoading(false)
                }
            }
        }
    }

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    const setMyOrderBoxFixed = () => {
        // if(window.scrollY >= 250){
        //     setMyOrderBoxFix(true)
        // }else{
        //     setMyOrderBoxFix(false)
        // }
    }

    //handle for special Instructions
    const handleSpecialInstructions = (event) => {
        const value = event.target.value;
        if (value !== "") {
            if(document.getElementById('specialInstructions')){
                document.getElementById('specialInstructions').value = '';
            }
            localStorage.setItem('specialInstruction',value);
            document.getElementById("specialInstructionsDiv").classList.remove("d-none")
            document.getElementById("specialInstructionsDiv").classList.add("d-block")
        } else {
            localStorage.removeItem('specialInstruction');
            localStorage.removeItem('additionalInstruction');
            document.getElementById("specialInstructionsDiv").classList.remove("d-block")
            document.getElementById("specialInstructionsDiv").classList.add("d-none")
        }
    }

    const handleChangeAdditionalInstructions = (event) =>{
        const value = event.target.value;
        if (value !== "") {
            localStorage.setItem('additionalInstruction',value);
        }
    }


    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row `}>
            {isLoading ? <Loader /> : ""}
            <div className="c-container">
                <div className={`row justify-content-center c-account-page c-school-page ${redeemReviewDetailsRef.current && 'c-steps-page'} c-shipping-page`}>
                    <div className={`col-12 col-md-11 my-md-5 ${redeemReviewDetailsRef.current ? 'my-5' : 'my-2'} px-0`}>
                        <div className="row cb-review-detail">

                            <div id="visibleElement" className={reviewDetailsRef.current ? "col-12 col-md-8" : ""}>
                                {reviewDetailsRef.current ?
                                    <div className="row">
                                        <div className="col-12 col-md-12 text-left mb-3">
                                            <h1 className="c-account-heading">
                                                Almost Done! Review and Place Your Order
                                            </h1>
                                        </div>
                                    </div>
                                    :
                                    redeemReviewDetailsRef.current ?
                                        <div className="row">
                                            <div className="col-12 col-md-12 text-left mb-3">
                                                <h1 className="c-account-heading">
                                                    {redeemReviewDetailsRef.current.voucherReviewHeading && redeemReviewDetailsRef.current.voucherReviewHeading}
                                                </h1>
                                            </div>
                                        </div>
                                        : ''

                                }
                                {reviewDetailsRef.current ? reviewDetailsRef.current.map((details) => {
                                    console.log('details-----shippping hide', details)
                                    const shouldShowRow =
                                        details.dropShipItems?.length > 0 ||
                                        details.groundOnlyItems?.length > 0 ||
                                        (
                                            details.softGoodsItems?.length > 0 &&
                                            (details.groundOnlyItems?.length > 0 ||
                                                details.dropShipItems?.length > 0 ||
                                                details.backOrderLivingMaterialItems?.length > 0 ||
                                                details.rtsProductItems?.length > 0 ||
                                                details.livingMaterialItems?.length > 0 ||
                                                details.specialLivingMaterialItems?.length > 0 ||
                                                details.nonLivingCategoryItems?.length > 0
                                            )
                                        ) ||
                                        details.backOrderLivingMaterialItems?.length > 0 ||
                                        details.rtsProductItems?.length > 0 ||
                                        details.livingMaterialItems?.length > 0 ||
                                        details.specialLivingMaterialItems?.length > 0 ||
                                        details.nonLivingCategoryItems?.length > 0;
                                    console.log('details-----shippping check', shouldShowRow)
                                    hideEditButton = details.hideEditInReview;
                                    return (
                                        <>

                                            <div className="row">
                                                {shouldShowRow &&
                                                    <div className="col-12 col-md-6">
                                                        <p className="c-review-title">Shipping <Link className="c-shipping-edit" to="/checkout/shipping" tabindex="1">edit</Link>
                                                        </p>
                                                        <address>
                                                            {details.recipientFirstNameForShippingDetails && details.recipientFirstNameForShippingDetails}&nbsp;{details.recipientLastNameForShippingDetails && details.recipientLastNameForShippingDetails}<br />
                                                            {details.companyNameForShippingDetails && <>{details.companyNameForShippingDetails}<br /></>}
                                                            {details.address1ForShippingDetails && details.address1ForShippingDetails}<br />
                                                            {details.address2ForShippingDetails ? <>{details.address2ForShippingDetails}<br /></> : details.locationForShippingDetails && <>{details.locationForShippingDetails}<br /></>}
                                                            {/* {details.locationForShippingDetails && <>{details.locationForShippingDetails}<br /></>} */}
                                                            {details.cityForShippingDetails && details.cityForShippingDetails},&nbsp;{details.stateForShippingDetails && details.stateForShippingDetails}&nbsp;{details.postalCodeForShippingDetails && details.postalCodeForShippingDetails}<br />
                                                            {details.recipientEmailForShippingDetails && details.recipientEmailForShippingDetails}<br />
                                                            {details.primaryPhoneNumberForShippingDetails && Helper.phoneNumberFormatter(details.primaryPhoneNumberForShippingDetails)}<br />
                                                        </address>
                                                    </div>
                                                }

                                                <div className="col-12 col-md-6 overflow-hidden">
                                                    <p className="c-review-title">Billing <Link className="c-shipping-edit" to="/checkout/billing" tabindex="2">edit</Link>
                                                    </p>
                                                    <address>
                                                        {details?.firstNameForPaymentDetails && details?.lastNameForPaymentDetails && details?.paymentType != 'Purchase order' && (
                                                            <>
                                                                {details.firstNameForPaymentDetails}&nbsp;{details.lastNameForPaymentDetails} <br />
                                                            </>
                                                        )}
                                                        {details?.companyNameForPaymentDetails && (
                                                            <>{details?.companyNameForPaymentDetails} <br /> </>
                                                        )}
                                                        {details.address1ForPaymentDetails && details.address1ForPaymentDetails}<br />
                                                        {details.address2ForPaymentDetails && <>{details.address2ForPaymentDetails}<br /></>}
                                                        {details.cityForPaymentDetails && details.cityForPaymentDetails},&nbsp;{details.StateForPaymentDetails && details.StateForPaymentDetails}&nbsp;{details.postalCodeForPaymentDetails && details.postalCodeForPaymentDetails}<br /><br />
                                                        Payment Method : <br />
                                                        {details.paymentType ? details.paymentType : ""}&nbsp;{details.PONumber ? details.PONumber : details.creditCardNumberForPaymentDetails ? <>************{details.creditCardNumberForPaymentDetails}</> : ""}<br />
                                                        {details.cardPoRefNumber ? `${"Reference Number: "}` + details.cardPoRefNumber : ""}
                                                    </address>
                                                </div>
                                            </div>
                                        </>
                                    )
                                }) : redeemReviewDetailsRef.current ?
                                    <div class="row mb-5 px-md-4 redeem-review-address">
                                        <div class="col-6 col-md-6">
                                            <p class="c-review-title">Shipping <Link to="/voucher/shipping" class="c-shipping-edit ms-3">edit</Link></p>
                                            <address>
                                                {redeemReviewDetailsRef.current.firstName}&nbsp;{redeemReviewDetailsRef.current.lastName}<br />
                                                {redeemReviewDetailsRef.current.address1}<br />
                                                {redeemReviewDetailsRef.current.address2 && <>{redeemReviewDetailsRef.current.address2}<br /></>}
                                                {redeemReviewDetailsRef.current.city},&nbsp;{redeemReviewDetailsRef.current.state}&nbsp;{redeemReviewDetailsRef.current.postalCode}<br />
                                                {redeemReviewDetailsRef.current.phoneNumber && Helper.phoneNumberFormatter(redeemReviewDetailsRef.current.phoneNumber)}<br />
                                                {redeemReviewDetailsRef.current.email}
                                                <br />
                                                <br />
                                            </address>
                                        </div>
                                    </div>
                                    :
                                    console.log("empty review details ref")}

                                {reviewDetailsRef.current ?
                                    <>
                                        <div className="row">
                                            <div className="col-12 col-md-12 text-left mb-3 mt-5">
                                                <h1 className="c-account-heading">Your Items</h1>
                                            </div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className="col-8 col-md-8">
                                                <p className="text-left mb-2 c-delivery-text">Items
                                                    <Link to="/checkout/cart" className="c-shipping-edit ps-2" tabindex="3">add/remove items</Link>
                                                </p>
                                            </div>
                                            <div className="col-4 col-md-4">
                                                <p className="text-left mb-2 c-delivery-text">Arrival Date
                                                {hideEditButton == "true" ? "" :
                                                    <Link to="/checkout/delivery" className="c-shipping-edit ps-2" tabindex="4">edit</Link>
                                                }</p>
                                            </div>
                                        </div>
                                    </> : redeemReviewDetailsRef.current ?
                                        <>
                                            <div className="row">
                                                <div className="col-md-12 text-left mb-4">
                                                    <h1 className="c-account-heading mb-2">Your Items</h1>
                                                </div>
                                            </div>

                                            <div className="row mb-2 px-md-4">
                                                <div className="col-7 col-md-6">
                                                    <p className="text-left mb-2 c-delivery-text">Items
                                                        {!isDistanceLearningRef.current ? <Link to="/voucher/redeem" className="c-shipping-edit ms-3" tabindex="3">edit</Link> : <></>}
                                                    </p>
                                                </div>
                                                <div className="col-5 col-md-4">
                                                    {!isDistanceLearningRef.current ?
                                                        <p className="text-left mb-2 c-delivery-text">Arrival Date
                                                            <Link to="/voucher/delivery" className="c-shipping-edit ms-3" tabindex="4">edit</Link>
                                                        </p> : <></>
                                                    }
                                                </div>
                                            </div>
                                        </>
                                        : ''}

                                {/* for special items present   */}
                                {specialProductItemRef.current ? specialProductItemRef.current.map((specialItemLists) => (
                                    <>
                                        {specialItemLists && Object.entries(specialItemLists).map(([key, specialItemList], index) => {

                                            var formattedStartDate = specialItemList?.arrivalStartDateForDropShipItem ? Helper.dateFormatter(specialItemList.arrivalStartDateForDropShipItem) :
                                                specialItemList?.arrivalStartDateForGroundOnlyItem ? Helper.dateFormatter(specialItemList.arrivalStartDateForGroundOnlyItem) :
                                                    specialItemList?.arrivalStartDateForsoftGoodsItem ? Helper.dateFormatter(specialItemList.arrivalStartDateForsoftGoodsItem) :
                                                        specialItemList?.deliveryDateForBackOrderLivingItem ? Helper.dateFormatter(specialItemList.deliveryDateForBackOrderLivingItem) :
                                                            specialItemList?.arrivalStartDateForRtsProductitem ? Helper.dateFormatter(specialItemList.arrivalStartDateForRtsProductitem) :
                                                                "";

                                            var formattedEndDate = specialItemList?.arrivalEndDateForDropShipItem ? Helper.dateFormatter(specialItemList.arrivalEndDateForDropShipItem) :
                                                specialItemList?.arrivalEndDateForGroundOnlyItem ? Helper.dateFormatter(specialItemList.arrivalEndDateForGroundOnlyItem) :
                                                    specialItemList?.arrivalEndDateForsoftGoodsItem ? Helper.dateFormatter(specialItemList.arrivalEndDateForsoftGoodsItem) :
                                                        specialItemList?.arrivalEndDateForBackOrderLivingItem ? Helper.dateFormatter(specialItemList.arrivalEndDateForBackOrderLivingItem) :
                                                            specialItemList?.arrivalEndDateForRtsProductitem ? Helper.dateFormatter(specialItemList.arrivalEndDateForRtsProductitem) :
                                                                "";

                                            // var formattedDate = specialItemList?.deliveryDateForBackOrderLivingItem && Helper.dateFormatter(specialItemList?.deliveryDateForBackOrderLivingItem)

                                            // const dateDisplayText = formattedDate ? formattedDate :
                                            //     formattedStartDate && formattedEndDate ? `${formattedStartDate} - ${formattedEndDate}` // Both dates
                                            //         : formattedStartDate || formattedEndDate; // One of the dates

                                            return (
                                                <div className="row mb-4 pb-2">
                                                    <div className="col-8 col-md-8">
                                                        <div className="c-delivery-item">
                                                            <span className="c-delivery-img">
                                                                <img onError={replaceImage} src={`${specialItemList?.imagePathForDropShipItem ? specialItemList.imagePathForDropShipItem :
                                                                    specialItemList?.imagePathForGroundOnlyItem ? specialItemList.imagePathForGroundOnlyItem :
                                                                        specialItemList?.imagePathForsoftGoodsItem ? specialItemList.imagePathForsoftGoodsItem :
                                                                            specialItemList?.imagePathForBackOrderLivingItem ? specialItemList.imagePathForBackOrderLivingItem :
                                                                                specialItemList?.imagePathForRtsProductitem ? specialItemList.imagePathForRtsProductitem : ""}`} />
                                                            </span>
                                                            <div className="c-delivery-items">
                                                                {(specialItemList?.backOrderTextMsgForDropShipItem || specialItemList?.backOrderTextMsgForBackOrderLivingItem || specialItemList?.backOrderTextMsgForRtsProductitem) &&
                                                                    <p class="c-delivery-item-text">
                                                                        {specialItemList?.backOrderTextMsgForDropShipItem ? specialItemList.backOrderTextMsgForDropShipItem :
                                                                            specialItemList?.backOrderTextMsgForBackOrderLivingItem ? specialItemList.backOrderTextMsgForBackOrderLivingItem :
                                                                                specialItemList?.backOrderTextMsgForRtsProductitem ? specialItemList.backOrderTextMsgForRtsProductitem : ""}
                                                                    </p>}
                                                                <p className="c-delivery-item-text fw-light">
                                                                    #{specialItemList?.itemNumberForDropShipItem ? specialItemList.itemNumberForDropShipItem :
                                                                        specialItemList?.itemNumberForGroundOnlyItem ? specialItemList.itemNumberForGroundOnlyItem :
                                                                            specialItemList?.itemNumberForsoftGoodsItem ? specialItemList.itemNumberForsoftGoodsItem :
                                                                                specialItemList?.itemNumberForBackOrderLivingItem ? specialItemList.itemNumberForBackOrderLivingItem :
                                                                                    specialItemList?.itemNumberForRtsProductitem ? specialItemList.itemNumberForRtsProductitem : ""}
                                                                    &nbsp;
                                                                    Qty:{specialItemList?.quantityForDropShipItem ? specialItemList.quantityForDropShipItem :
                                                                        specialItemList?.quantityForGroundOnlyItem ? specialItemList.quantityForGroundOnlyItem :
                                                                            specialItemList?.quantityForsoftGoodsItem ? specialItemList.quantityForsoftGoodsItem :
                                                                                specialItemList?.quantityForBackOrderLivingItem ? specialItemList.quantityForBackOrderLivingItem :
                                                                                    specialItemList?.quantityForRtsProductitem ? specialItemList.quantityForRtsProductitem : ""}
                                                                </p>
                                                                <p className="c-delivery-item-text fw-light" dangerouslySetInnerHTML={{
                                                                    __html: specialItemList?.productDescForDropShipItem ? specialItemList.productDescForDropShipItem :
                                                                        specialItemList?.productDescForGroundOnlyItem ? specialItemList.productDescForGroundOnlyItem :
                                                                            specialItemList?.productDescForsoftGoodsItem ? specialItemList.productDescForsoftGoodsItem :
                                                                                specialItemList?.productDescForBackOrderLivingItem ? specialItemList.productDescForBackOrderLivingItem :
                                                                                    specialItemList?.productDescForRtsProductitem ? specialItemList.productDescForRtsProductitem :
                                                                                        ""
                                                                }}>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-4 col-md-4 align-self-center c-delivery-arrival">

                                                        {/* <p className="text-left mb-0 c-delivery-content">
                                                                {dateDisplayText && dateDisplayText}
                                                                </p> */}
                                                        {specialItemList?.itemNumberForsoftGoodsItem || specialItemList?.itemNumberForBackOrderLivingItem ?
                                                            <p className="text-left mb-0 c-delivery-content">
                                                                {formattedStartDate}
                                                            </p> :
                                                            <p className="text-left mb-0 c-delivery-content">
                                                                {`${formattedStartDate} - ${formattedEndDate}`}
                                                            </p>}

                                                        <p className="text-left mb-0 c-delivery-content">{
                                                            specialItemList && (
                                                                specialItemList.shippingMethodForDropShipItem ? specialItemList.shippingMethodForDropShipItem :
                                                                    specialItemList.shippingMethodForGroundOnlyItem ? specialItemList.shippingMethodForGroundOnlyItem :
                                                                        specialItemList.shippingMethodForsoftGoodsItem ? specialItemList?.overNightMsg :
                                                                            specialItemList.shippingMethodForBackOrderLivingItem ? specialItemList.shippingMethodForBackOrderLivingItem :
                                                                                specialItemList.shippingMethodForRtsProductitem ? specialItemList.shippingMethodForRtsProductitem :
                                                                                    '')
                                                        }</p>

                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </>
                                )) : ""}

                                {/* for living items present  */}
                                {livingProductItemRef.current ? livingProductItemRef.current.map((livingProducts) => (
                                    <>
                                        {livingProducts && Object.entries(livingProducts).map(([key, livingProduct], index) => {

                                            // var formattedDeliveryDateForlivingMaterialItem = Helper.dateFormatter(livingProduct?.deliveryDateForlivingMaterialItem ? livingProduct.deliveryDateForlivingMaterialItem :
                                            //      livingProduct?.deliveryDateForspeciallivingMaterialItem ? livingProduct.deliveryDateForspeciallivingMaterialItem : "");

                                            var formattedStartDate = livingProduct?.arrivalStartDateForlivingMaterialItem ? Helper.dateFormatter(livingProduct.arrivalStartDateForlivingMaterialItem) :
                                                livingProduct?.arrivalStartDateForspeciallivingMaterialItem ? Helper.dateFormatter(livingProduct.arrivalStartDateForspeciallivingMaterialItem) :
                                                    "";

                                            var formattedEndDate = livingProduct?.arrivalEndDateForlivingMaterialItem ? Helper.dateFormatter(livingProduct.arrivalEndDateForlivingMaterialItem) :
                                                livingProduct?.arrivalEndDateForspeciallivingMaterialItem ? Helper.dateFormatter(livingProduct.arrivalEndDateForspeciallivingMaterialItem) :
                                                    "";

                                            var formattedDate = livingProduct?.deliveryDateForlivingMaterialItem ? Helper.dateFormatter(livingProduct?.deliveryDateForlivingMaterialItem) :
                                                livingProduct?.deliveryDateForspeciallivingMaterialItem ? Helper.dateFormatter(livingProduct?.deliveryDateForspeciallivingMaterialItem) : ''

                                            const dateDisplayText = formattedDate ? formattedDate :
                                                formattedStartDate && formattedEndDate ? `${formattedStartDate} - ${formattedEndDate}` // Both dates
                                                    : formattedStartDate || formattedEndDate; // One of the dates

                                            return (
                                                <div className="row mb-4 pb-2">
                                                    <div className="col-8 col-md-8">
                                                        <div className="c-delivery-item">
                                                            <span className="c-delivery-img">
                                                                <img onError={replaceImage} src={`${livingProduct?.imagePathForlivingMaterialItem ? livingProduct.imagePathForlivingMaterialItem :
                                                                    livingProduct?.imagePathForspeciallivingMaterialItem ? livingProduct.imagePathForspeciallivingMaterialItem : ""}`}
                                                                />
                                                            </span>
                                                            <div className="c-delivery-items">
                                                                <p className="c-delivery-item-text fw-light">#{livingProduct?.itemNumberForlivingMaterialItem ? livingProduct.itemNumberForlivingMaterialItem :
                                                                    livingProduct?.itemNumberForspeciallivingMaterialItem ? livingProduct.itemNumberForspeciallivingMaterialItem : ""}&nbsp;&nbsp;Qty:{livingProduct?.quantityForlivingMaterialItem ? livingProduct.quantityForlivingMaterialItem :
                                                                        livingProduct?.quantityForspeciallivingMaterialItem ? livingProduct.quantityForspeciallivingMaterialItem : ""}
                                                                </p>
                                                                <p className="c-delivery-item-text fw-light" dangerouslySetInnerHTML={{
                                                                    __html: livingProduct?.productDescForlivingMaterialItem ? livingProduct.productDescForlivingMaterialItem :
                                                                        livingProduct?.productDescForspeciallivingMaterialItem ? livingProduct.productDescForspeciallivingMaterialItem : ""
                                                                }}>
                                                                </p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-4 col-md-4 align-self-center c-delivery-arrival">
                                                        <p className="text-left mb-0 c-delivery-content">{dateDisplayText && dateDisplayText}</p>
                                                        <p className="text-left mb-0 c-delivery-content">
                                                            {livingProduct?.shippingMethodForlivingMaterialItem ? livingProduct.shippingMethodForlivingMaterialItem :
                                                                livingProduct?.shippingMethodForspeciallivingMaterialItem ? livingProduct.shippingMethodForspeciallivingMaterialItem :
                                                                    ""}
                                                        </p>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </>
                                )) : ""}

                                {/* for non living items present   */}
                                {nonLivingProductItemRef.current ? nonLivingProductItemRef.current.map((nonLivingProducts) => (
                                    <>
                                        {nonLivingProducts && Object.entries(nonLivingProducts).map(([key, nonLivingProduct], index) => {

                                            var formattedStartDate = nonLivingProduct?.arrivalStartDateFornonLiveMaterialitem ? Helper.dateFormatter(nonLivingProduct.arrivalStartDateFornonLiveMaterialitem) : "";
                                            var formattedEndDate = nonLivingProduct?.arrivalEndDateFornonLiveMaterialitem ? Helper.dateFormatter(nonLivingProduct.arrivalEndDateFornonLiveMaterialitem) : "";

                                            var formattedDate = nonLivingProduct?.deliveryDateFornonLiveMaterialitem && Helper.dateFormatter(nonLivingProduct?.deliveryDateFornonLiveMaterialitem)

                                            const dateDisplayText = formattedDate ? formattedDate :
                                                formattedStartDate && formattedEndDate ? `${formattedStartDate} - ${formattedEndDate}` // Both dates
                                                    : formattedStartDate || formattedEndDate;
                                            return (
                                                <div className="row mb-4 pb-2">
                                                    <div className="col-8 col-md-8">
                                                        <div className="c-delivery-item">
                                                            <span className="c-delivery-img">
                                                                <img src={`${nonLivingProduct?.imagePathFornonLiveMaterialitem ? nonLivingProduct.imagePathFornonLiveMaterialitem : ""}`}
                                                                    onError={replaceImage} />
                                                            </span>
                                                            <div className="c-delivery-items">
                                                                <p className="c-delivery-item-text fw-light">#{nonLivingProduct?.itemNumberFornonLiveMaterialitem ? nonLivingProduct.itemNumberFornonLiveMaterialitem : ""}&nbsp;&nbsp;Qty:{nonLivingProduct?.quantityFornonLiveMaterialitem ? nonLivingProduct.quantityFornonLiveMaterialitem : ""}</p>
                                                                <p className="c-delivery-item-text fw-light" dangerouslySetInnerHTML={{ __html: nonLivingProduct?.productDescFornonLiveMaterialitem ? nonLivingProduct.productDescFornonLiveMaterialitem : "" }}>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-4 col-md-4 align-self-center c-delivery-arrival">

                                                        {/* <p className="text-left mb-0 c-delivery-content">{dateDisplayText && dateDisplayText}</p> */}
                                                        {/* {handleDateCompare(nonLivingProduct?.arrivalStartDateFornonLiveMaterialitem, nonLivingProduct?.arrivalEndDateFornonLiveMaterialitem) == "equal" ?
                                                            <p className="text-left mb-0 c-delivery-content">{handleDateFormat(nonLivingProduct?.arrivalStartDateFornonLiveMaterialitem)}</p> :
                                                            reviewDetailsRef.current?.shippingPreferenceForNonLiving == "ship-Later" || reviewDetailsRef.current?.shippingPreferenceForNonLiving == "ship-Immediate" ?
                                                                <p className="text-left mb-0 c-delivery-content">{handleDateFormat(nonLivingProduct?.arrivalStartDateFornonLiveMaterialitem)}</p> :
                                                                <p className="text-left mb-0 c-delivery-content">
                                                                    {handleDateFormat(nonLivingProduct.arrivalStartDateFornonLiveMaterialitem).concat(" - ").concat(handleDateFormat(nonLivingProduct.arrivalEndDateFornonLiveMaterialitem))}
                                                                </p>
                                                        } */}

                                                        {(nonLivingProduct?.shippingMethodFornonLiveMaterialitem == "Standard Ground") && (shipPreferenceRef.current?.shippingPreferenceForNonLiving == "ship-Later") ?
                                                            <p className="text-left mb-0 c-delivery-content">{handleDateFormat(nonLivingProduct?.arrivalStartDateFornonLiveMaterialitem)}</p> :
                                                            nonLivingProduct?.shippingMethodFornonLiveMaterialitem !== "Standard Ground" ?
                                                                <p className="text-left mb-0 c-delivery-content">{handleDateFormat(nonLivingProduct?.arrivalStartDateFornonLiveMaterialitem)}</p>
                                                                : <p className="text-left mb-0 c-delivery-content">
                                                                    {handleDateFormat(nonLivingProduct?.arrivalStartDateFornonLiveMaterialitem).concat(" - ").concat(handleDateFormat(nonLivingProduct?.arrivalEndDateFornonLiveMaterialitem))}
                                                                </p>}
                                                        <p className="text-left mb-0 c-delivery-content">{nonLivingProduct?.shippingMethodFornonLiveMaterialitem ? nonLivingProduct.shippingMethodFornonLiveMaterialitem : ""}</p>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </>
                                )) : ""}


                                {redeemProductDetailsRef.current ?
                                    <div class="cv-vline">
                                        {redeemProductDetailsRef.current.living && redeemProductDetailsRef.current.living.map((product, index) => {

                                            return (
                                                <>
                                                    {product.voucherId && product.voucherId.trim() != '' &&
                                                        <div class="row mb-5 px-md-4">
                                                            <div class="col-7 col-md-6">
                                                                <div class="c-delivery-item">
                                                                    <div class="c-delivery-items">
                                                                        <p class="c-delivery-item-text">Code: {product.voucherId ? product.voucherId : ''}</p>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-5 col-md-4 align-items-start d-flex">
                                                                <div>
                                                                    <p class="text-left mb-0 c-delivery-content">
                                                                        {product.livingDeliverydate ? product.livingDeliverydate : ''}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        })

                                        }
                                        {redeemProductDetailsRef.current.curriculum && redeemProductDetailsRef.current.curriculum.map((product, index) => {

                                            return (
                                                <>
                                                    {product.voucherId && product.voucherId.trim() != '' &&
                                                        <div class="row mb-5 px-md-4">
                                                            <div class="col-7 col-md-6">
                                                                <div class="c-delivery-item">
                                                                    <div class="c-delivery-items">
                                                                        <p class="c-delivery-redeem-item-text">Code: &nbsp; {product.voucherId ? product.voucherId : ''}</p>
                                                                        <p class="c-delivery-redeem-item-text">{product.schoolName ? product.schoolName : ''}</p>
                                                                        <p class="c-delivery-redeem-item-text">{product.courseTitle ? product.courseTitle : ''}</p>
                                                                        <p class="c-delivery-redeem-item-text">{product.courseId ? product.courseId : ''}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-5 col-md-4 align-items-start d-flex">
                                                                <div>
                                                                    <p class="text-left mb-0 c-delivery-content">
                                                                        {product.curriculamDeliverydate ? product.curriculamDeliverydate : ''}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        })

                                        }
                                        {redeemProductDetailsRef.current.distanceLearning && redeemProductDetailsRef.current.distanceLearning.map((product, index) => {

                                            return (
                                                <>
                                                    {product.voucherId && product.voucherId.trim() != '' &&
                                                        <div class="row mb-5 px-md-4">
                                                            <div class="col-7 col-md-6">
                                                                <div class="c-delivery-item">
                                                                    <div class="c-delivery-items">
                                                                        <p class="c-delivery-item-text">Code: &nbsp; {product.voucherId ? product.voucherId : ''}</p>
                                                                        <p class="c-delivery-item-text">{product.schoolName ? product.schoolName : ''}</p>
                                                                        <p class="c-delivery-item-text">{product.courseTitle ? product.courseTitle : ''}</p>
                                                                        <p class="c-delivery-item-text">{product.courseId ? product.courseId : ''}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-5 col-md-4 align-items-start d-flex">
                                                                <div>
                                                                    <p class="text-left mb-0 c-delivery-content">{product?.deliveryMessage}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        })

                                        }

                                    </div> : ""}

                                {reviewDetailsRef.current ?
                                    <>
                                        <div className="row mb-3 mt-5">
                                            <div className="col-12 col-md-12">
                                                <p className="c-review-content fw-normal">
                                                    Products labeled and/or advertised <i>for educational use only</i> may only be used for educational purposes. Commercial use, resale, and research use for other than educational purposes, are all prohibited. Unauthorized uses must be recalled and destroyed.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="row my-2 align-items-center">
                                            <div className="col-auto">
                                                <label className="form-label mb-0" htmlFor="specialRequest">(Optional) Special Request?</label>
                                            </div>
                                            <div className="col-auto">
                                                <select className="form-select" id="specialRequest" name="specialRequest" onChange={handleSpecialInstructions}>
                                                    <option  value="">-- None --</option>
                                                    {specialInstructionRef.current.map((message) => {
                                                        return (
                                                            <option selected={localStorage.getItem('specialInstruction') == message?true:false} value={message}>{message}</option>
                                                        )
                                                    })

                                                    }
                                                    
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row g-3 mb-4 mt-2">
                                            <div class={localStorage.getItem('specialInstruction') ? "col-12 col-md-12" : "col-12 col-md-12 d-none"} id="specialInstructionsDiv" >
                                                <label for="additional" class="form-label">Additional Instructions? (optional)</label>
                                                <textarea maxlength="120" tabindex="5" name="specialInstructions" id="specialInstructions" onChange={handleChangeAdditionalInstructions} rows="3" class="form-control form-textarea" defaultValue={localStorage.getItem('additionalInstruction')}></textarea>
                                            </div>

                                            {/* <div className="col-12 col-md-12" id="additionalInstructions" >
                                                <label htmlFor="additional" className="form-label">Additional Instructions? (optional)</label>
                                            </div> */}
                                            <div className="col-12 col-md-12 c-have-question">Have additional questions? <Link className="fw-bold" to="/our-company/checkout-faq">Read our ordering FAQ page.</Link> </div>
                                        </div>
                                    </> : ""}
                                <div className="row g-3 mb-3 mt-5">
                                    {reviewDetailsRef.current ?
                                        <div className="col-md-6 d-grid">
                                            <button onClick={handleSubmitOrder} className="btn btn-primary btn-carolina no-padding-lr w-100 mt-2" tabindex="7" >{submitButton}</button>
                                        </div>
                                        :
                                        redeemReviewDetailsRef.current
                                            ?
                                            <div className="col-md-4 d-grid">
                                                <button onClick={handleSubmitOrder} className="btn btn-primary btn-carolina no-padding-lr w-100 mt-2" tabindex="7" >{submitButton}</button>
                                            </div>
                                            : ''
                                    }
                                </div>
                            </div>

                            {reviewDetailsRef.current ? <OrderSummary orderSummaryDetails={orderSummaryDetailsRef.current} handleSubmitOrder={handleSubmitOrder} handleCallBackOrderSummary={handleCallBackOrderSummary} /> : ""}
                        </div>
                        <div id="checkoutSpacer"></div>

                    </div>
                    <div className="modal fade c-modal" id="default-modal" tabindex="-1" aria-labelledby="defaultModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                            <div className="modal-content">
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                </button>
                                <div className="modal-body">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CheckoutReview;
